import { createContext, useContext, useEffect, useState } from "react";
import * as api from "@/lib/api";

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api
      .getSettings()
      .then(setSettings)
      .catch(() => setSettings({}));
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
